module.exports = __webpack_public_path__ + "img/EY__bg_sm.52b2ea6a.png";